import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=5d5453b1&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=5d5453b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5453b1",
  null
  
)

export default component.exports